import { observer } from "mobx-react";
import { observable, makeObservable } from "mobx";
import React from "react";
import { DateTime } from "luxon";
import { formatDuration } from "./dateTimeUtils";

class TimeAgo extends React.Component {
  constructor(props) {
    super(props);
    this.store = new TimeAgoStore();
    this.interval = setInterval(() => this.store.updateTime(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  /**
   * Calculates the maximum time of all records
   * @param {Object} params
   * @param {Boolean} params.liveMode
   * @param {DateTime} params.endTime
   * @param {Array} params.records
   * @returns {string}
   */
  getTimeAgo({ endTime, precision } = this.props) {
    //If Live Mode is turned off, return the difference between endTime and now
    const now = this.store.time;
    const _endTime = endTime;
    const fromNow = now.diff(_endTime, ["minutes", "seconds"]);
    if (precision === "seconds") {
      return formatDuration(fromNow);
    }
    if (fromNow.minutes < 1) return "0 minutes ago";
    return formatDuration(fromNow);
  }

  render() {
    return (
      <div className={this.props.className || "delay"}>{this.getTimeAgo()}</div>
    );
  }
}

export default observer(TimeAgo);

class TimeAgoStore {
  time = DateTime.local();

  constructor() {
    makeObservable(this, {
      time: observable,
    });
  }

  updateTime() {
    this.time = DateTime.local();
  }
}
